const formatNumber = (amount, decimals = 0, thousandsSep = ' ') => {
  // Денежное поле не должно показывать «не число»: если пришло не-конечное
  // значение (undefined/NaN/null от сломанного контракта — напр. price или
  // oldPrice из window.productItems живого поиска), приводим к 0. В не-prod
  // сигналим в консоль, чтобы ловить будущие NaN, не зашумляя боевую консоль.
  const rawAmount = amount;
  amount = Number(amount);
  if (!Number.isFinite(amount)) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('formatNumber: получено не-конечное значение, приведено к 0:', rawAmount);
    }
    amount = 0;
  }

  const formatter = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: true,
  });

  let number = formatter.format(amount);
  number = number.replace(/[,\.]00$/, '');
  number = number.replace( /(\d)\s(\d)/, /*amount <= 9999 ? '$1$2' : */'$1 $2' );
  
  return number;
};

const formatPrice = (amount, decimals = 2, thousandsSep = ' ') => {
  return formatNumber( amount, decimals, thousandsSep ) + '&nbsp;₽';
};

export { formatNumber, formatPrice };
